import cookie from "js-cookie";
import { apiUrl } from "./apiUrl";
import { getSucursal } from "./helpers";
import { permisions } from "./permisions";

export const auth = {
    getUser: () => {
        let user = window.localStorage.getItem("user");
        user = JSON.parse(user);
        user.sucursalActual = parseInt(
            window.localStorage.getItem("sucursalActual")
        );
        return user;
    },
    getToken: () => {
        return cookie.get("token");
    },
    is: (rol) => {
        return auth.getUser().rol === rol;
    },
    can: (ability) => {
        const rol = auth.getUser().rol;

        //soporte para Roles
        if (rol) {
            const puede = auth.permissions[rol]?.indexOf(ability) > -1;

            // si el rol tiene la habilidad retornar true else validar tenga el permiso
            if (puede) return puede;
        }

        return (auth.getUser().permisos ?? []).includes(ability);
    },
    canEdit: (ability) => {
        const val = `${ability}-no-editar`;

        return !auth.can(val);
    },
    getConfig: () => {
        const predeterminado = {
            unidad_produccion_p: 'Toneladas',
            unidad_produccion_s: 'Tonelada',
            unidad_produccion_abr: 'TON.',
        }

        const config = JSON.parse(window.localStorage.getItem("config"));

        return config.unidad_produccion_p ? config : predeterminado;
    },
    permissions: {
        "super-admin": [
            permisions.editarUsuarios,
            permisions.verDashboard,
            permisions.abrirTarjeta,
            permisions.verConfiguracion,
            permisions.verProgramacion,
            permisions.verEmpleados,
            permisions.verAusencias,
            permisions.verNomina,
            permisions.verSolicitudes,
            permisions.verReclamaciones,
            permisions.verDescuentos,
            permisions.verIncentivos,
            permisions.verVehiculos,
            permisions.verRutas,
            permisions.verInventario,
            permisions.verActivoFijo,
            permisions.crearActivoFijo,
            permisions.editarActivoFijo,
            permisions.verUbicaciones,
            permisions.verAlmacenes,
            permisions.verContratos,
            permisions.editarInventario,
            permisions.verGastosGenerales,
            permisions.verGastos,
            permisions.crearGastos,
            permisions.editarGastos,
            permisions.verCompras,
            permisions.verComprasRecurrentes,
            permisions.verServicios,
            permisions.verReportes,
            permisions.verContactos,
            permisions.editarSucursales,
            permisions.verTipos,
            permisions.verCuentas,
            permisions.verGiGrupos,
            permisions.verGiPrestamos,
            permisions.verGiServidores,
            permisions.verGrupoTiposEmpleados,
            permisions.verIngresos,
            permisions.verFacturas,
            permisions.verFacturasRecurrentes,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.verCotizaciones,
            permisions.verComprobantes,
            permisions.verProductos,
            permisions.verCategorias,
            permisions.crearProductos,
            permisions.editarProductos,
            permisions.eliminarProductos,
            permisions.movimientoMasivos,
            permisions.exportarCatalogo,
            permisions.verGastosInternos,
            permisions.verPlantillasImpresion,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso,
            permisions.verAcademico,
            permisions.verCuentasPorPagar,
            permisions.verEvaluaciones,
            permisions.verEstudiantes,
            permisions.verInscripcion,
            permisions.verFacturacionAcademica,
            permisions.verPadrestutores,
            permisions.verContabilidad,
            permisions.verCheque,
            permisions.verCuentaContable,
            permisions.verEntradasDiarios,
            permisions.verReporteContables,
            permisions.verNotasCredito,
            permisions.salud,
            permisions.visitaSalud,
            permisions.pacientes,
            permisions.inventarioSalud,
            permisions.verCartas,
            permisions.verPlantillas,
            permisions.reporteSalud,
            permisions.reporteSaludVisitas,
            permisions.reporteSaludInsumos,
            permisions.reporteContabilidad,
            permisions.reporteContabilidadCuentas,
            permisions.reporteContabilidadTransacciones,
            permisions.reporteContabilidadCheques,
            permisions.reporteContabilidadEntradaDiario,
            permisions.reporteContratos,
            permisions.reporteIngreso,
            permisions.reporteFacturaReporteFacturas,
            permisions.reporteFacturaResumenFacturas,
            permisions.reporteFacturaDetalleImpuesto,
            permisions.reporteFacturaCuadreCaja,
            permisions.reporteFacturaCuadreCajaResumido,
            permisions.reporteFacturaListaCarga,
            permisions.reporteFacturaBalance,
            permisions.reporteFacturaBalanceDetalle,
            permisions.reporteFacturaRutaDistribucion,
            permisions.reporteFacturaPlanificacionTareas,
            permisions.reporteFacturaCuadreCajaVentas,
            permisions.reporteFacturaRecurentes,
            permisions.reporteCotizaciones,
            permisions.reporteOrdenesCompraDetalles,
            permisions.reporteOrdenesCompraResumen,
            permisions.reporteOrdenesCompraListaEntrega,
            permisions.reporteDespachoFacturasListaCarga,
            permisions.reporteDespachoFacturasOrdenCarga,
            permisions.reporteDespachoFacturas,
            permisions.reporteConsultas,
            permisions.reporteCuentaPorCobrarDetalles,
            permisions.reporteCuentaPorCobrarEstadoCuenta,
            permisions.reporteCuentaPorCobrarResumen,
            permisions.reporteCuentaPorPagarDetalles,
            permisions.reporteCuentaPorPagarResumen,
            permisions.reporteRecibos,
            permisions.reporteNotaCredito,
            permisions.reporteNotaCreditoDetalleImpuesto,
            permisions.reporteOperaciones,
            permisions.reporteOperacionesGrupos,
            permisions.reporteOperacionesPrestamos,
            permisions.reporteEmpleados,
            permisions.reporteEmpleadosListado,
            permisions.reporteEmpleadosDetalle,
            permisions.reporteEmpleadosCompararNomina,
            permisions.reporteEmpleadosCumpleanos,
            permisions.reporteEmpleadosSalarioNavidad,
            permisions.reporteEmpleadosSalarioNavidadDetalle,
            permisions.reporteEmpleadosSalarioNavidadSobre,
            permisions.reporteEmpleadosSalarioNavidadDesgloses,
            permisions.reporteEmpleadosSalarioNavidadVolantes,
            permisions.reporteEmpleadosAperturaCuentaBR,
            permisions.reporteEmpleadosVacacionesPendientes,
            permisions.reporteAusencias,
            permisions.reporteAusenciasGeneral,
            permisions.reporteAusenciasVacaciones,
            permisions.reporteDescuentos,
            permisions.reporteIncentivos,
            permisions.reporteSolicitudes,
            permisions.reporteReclamaciones,
            permisions.reporteVehiculos,
            permisions.reporteVehiculosListado,
            permisions.reporteVehiculosLDetalle,
            permisions.reporteServicios,
            permisions.reporteZonas,
            permisions.reporteInventario,
            permisions.reporteInventarioProductosRealizarInventario,
            permisions.reporteInventarioProductosInventario,
            permisions.reporteInventarioProductosReordern,
            permisions.reporteInventarioProductosBalance,
            permisions.reporteInventarioProductosOperaciones,
            permisions.reporteInventarioProductosInventarioCentas,
            permisions.reporteInventarioProductosPorSuplidor,
            permisions.reporteInventarioActivoFijos,
            permisions.reporteInventarioActivoFijosReorden,
            permisions.reporteInventarioCompras,
            permisions.reporteInventarioComprasCuadre,
            permisions.reporteInventarioComprasDetalleImpuesto,
            permisions.reporteInventarioDespachoInterno,
            permisions.verCuadreCaja,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.reporteOrdenesCuadreCaja,
            permisions.reporteOrdenesCuadreCajaVenta,
            permisions.verNotasDebito,
            permisions.reporteNotaDebito,
            permisions.reporteNotaDebitoDetalleImpuesto,
            permisions.reporteCuentaPorPagarEstadoCuenta,
        ],
        admin: [
            permisions.verDashboard,
            permisions.abrirTarjeta,
            permisions.verConfiguracion,
            permisions.verProgramacion,
            permisions.verEmpleados,
            permisions.verAusencias,
            permisions.verNomina,
            permisions.verSolicitudes,
            permisions.verReclamaciones,
            permisions.verDescuentos,
            permisions.verIncentivos,
            permisions.verVehiculos,
            permisions.verRutas,
            permisions.verInventario, 
            permisions.verActivoFijo, 
            permisions.crearActivoFijo,
            permisions.editarActivoFijo,
            permisions.verUbicaciones,
            permisions.verAlmacenes,
            permisions.verCategorias,
            permisions.editarInventario,
            permisions.verGastos,
            permisions.crearGastos,
            permisions.editarGastos,
            permisions.verGastosGenerales,
            permisions.verGastosInternos,
            permisions.verCompras,
            permisions.verComprasRecurrentes,
            permisions.verContratos,
            permisions.verServicios,
            permisions.verReportes,
            permisions.verContactos,
            permisions.verTipos,
            permisions.verCuentas,
            permisions.verGiGrupos,
            permisions.verGiPrestamos,
            permisions.verGiServidores,
            permisions.verGrupoTiposEmpleados,
            permisions.verProductos,
            permisions.crearProductos,
            permisions.editarProductos,
            permisions.eliminarProductos,
            permisions.movimientoMasivos,
            permisions.exportarCatalogo,
            permisions.verComprobantes,
            permisions.verIngresos,
            permisions.verFacturas,
            permisions.verFacturasRecurrentes,
            permisions.verCotizaciones,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.verPlantillasImpresion,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verCuentasPorPagar,
            permisions.verRecibosIngreso,
            permisions.verAcademico,
            permisions.verEvaluaciones,
            permisions.verEstudiantes,
            permisions.verInscripcion,
            permisions.verFacturacionAcademica,
            permisions.verPadrestutores,
            permisions.verContabilidad,
            permisions.verCheque,
            permisions.verCuentaContable,
            permisions.verEntradasDiarios,
            permisions.verReporteContables,
            permisions.verNotasCredito,
            permisions.reporteSalud,
            permisions.reporteSaludVisitas,
            permisions.reporteSaludInsumos,
            permisions.reporteContabilidad,
            permisions.reporteContabilidadCuentas,
            permisions.reporteContabilidadTransacciones,
            permisions.reporteContabilidadCheques,
            permisions.reporteContabilidadEntradaDiario,
            permisions.reporteContratos,
            permisions.reporteIngreso,
            permisions.reporteFacturaReporteFacturas,
            permisions.reporteFacturaResumenFacturas,
            permisions.reporteFacturaDetalleImpuesto,
            permisions.reporteFacturaCuadreCaja,
            permisions.reporteFacturaCuadreCajaResumido,
            permisions.reporteFacturaListaCarga,
            permisions.reporteFacturaBalance,
            permisions.reporteFacturaBalanceDetalle,
            permisions.reporteFacturaRutaDistribucion,
            permisions.reporteFacturaPlanificacionTareas,
            permisions.reporteFacturaCuadreCajaVentas,
            permisions.reporteFacturaRecurentes,
            permisions.reporteCotizaciones,
            permisions.reporteOrdenesCompraDetalles,
            permisions.reporteOrdenesCompraResumen,
            permisions.reporteOrdenesCompraListaEntrega,
            permisions.reporteDespachoFacturasListaCarga,
            permisions.reporteDespachoFacturasOrdenCarga,
            permisions.reporteDespachoFacturas,
            permisions.reporteConsultas,
            permisions.reporteCuentaPorCobrarDetalles,
            permisions.reporteCuentaPorCobrarEstadoCuenta,
            permisions.reporteCuentaPorCobrarResumen,
            permisions.reporteCuentaPorPagarDetalles,
            permisions.reporteCuentaPorPagarResumen,
            permisions.reporteRecibos,
            permisions.reporteNotaCredito,
            permisions.reporteNotaCreditoDetalleImpuesto,
            permisions.reporteOperaciones,
            permisions.reporteOperacionesGrupos,
            permisions.reporteOperacionesPrestamos,
            permisions.reporteEmpleados,
            permisions.reporteEmpleadosListado,
            permisions.reporteEmpleadosDetalle,
            permisions.reporteEmpleadosCompararNomina,
            permisions.reporteEmpleadosCumpleanos,
            permisions.reporteEmpleadosSalarioNavidad,
            permisions.reporteEmpleadosSalarioNavidadDetalle,
            permisions.reporteEmpleadosSalarioNavidadSobre,
            permisions.reporteEmpleadosSalarioNavidadDesgloses,
            permisions.reporteEmpleadosSalarioNavidadVolantes,
            permisions.reporteEmpleadosAperturaCuentaBR,
            permisions.reporteEmpleadosVacacionesPendientes,
            permisions.reporteAusencias,
            permisions.reporteAusenciasGeneral,
            permisions.reporteAusenciasVacaciones,
            permisions.reporteDescuentos,
            permisions.reporteIncentivos,
            permisions.reporteSolicitudes,
            permisions.reporteReclamaciones,
            permisions.reporteVehiculos,
            permisions.reporteVehiculosListado,
            permisions.reporteVehiculosLDetalle,
            permisions.reporteServicios,
            permisions.reporteZonas,
            permisions.reporteInventario,
            permisions.reporteInventarioProductosRealizarInventario,
            permisions.reporteInventarioProductosInventario,
            permisions.reporteInventarioProductosReordern,
            permisions.reporteInventarioProductosBalance,
            permisions.reporteInventarioProductosOperaciones,
            permisions.reporteInventarioProductosInventarioCentas,
            permisions.reporteInventarioProductosPorSuplidor,
            permisions.reporteInventarioActivoFijos,
            permisions.reporteInventarioActivoFijosReorden,
            permisions.reporteInventarioCompras,
            permisions.reporteInventarioComprasCuadre,
            permisions.reporteInventarioComprasDetalleImpuesto,
            permisions.reporteInventarioDespachoInterno,
            permisions.verCuadreCaja,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.reporteOrdenesCuadreCaja,
            permisions.reporteOrdenesCuadreCajaVenta,
            permisions.verNotasDebito,
            permisions.reporteNotaDebito,
            permisions.reporteNotaDebitoDetalleImpuesto,
            permisions.reporteCuentaPorPagarEstadoCuenta,
        ],
        rrhh: [
            permisions.verDashboard,
            permisions.verConfiguracion,
            permisions.verProgramacion,
            permisions.verEmpleados,
            permisions.verAusencias,
            permisions.verNomina,
            permisions.verSolicitudes,
            permisions.verReclamaciones,
            permisions.verVehiculos,
            permisions.verRutas,
            permisions.verInventario,
            permisions.verActivoFijo,
            permisions.crearActivoFijo,
            permisions.editarActivoFijo,
            permisions.verUbicaciones,
            permisions.verAlmacenes,
            permisions.verCategorias,
            permisions.editarInventario,
            permisions.verGastos,
            permisions.crearGastos,
            permisions.editarGastos,
            permisions.verGastosGenerales,
            permisions.verGastosInternos,
            permisions.verCompras,
            permisions.verComprasRecurrentes,
            permisions.verServicios,
            permisions.verReportes,
            permisions.verContactos,
        ],
        nomina: [
            permisions.verEmpleados,
            permisions.verAusencias,
            permisions.verTipos,
            permisions.verNomina,
            permisions.verDescuentos,
            permisions.verIncentivos,
            permisions.verGiGrupos,
            permisions.verGiPrestamos,
            permisions.verGiServidores,
        ],
        editor: [
            permisions.verProgramacion,
            permisions.verIngresos,
            permisions.verFacturas,
            permisions.verVehiculos,
            permisions.verCotizaciones,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.verDescuentos,
            permisions.verServicios,
            permisions.verInventario,
            permisions.verActivoFijo,
            permisions.crearActivoFijo,
            permisions.editarActivoFijo,
            permisions.verUbicaciones,
            permisions.verAlmacenes,
            permisions.verCategorias,
            permisions.editarInventario,
            permisions.verCompras,
            permisions.verComprasRecurrentes,
            permisions.verGastos,
            permisions.crearGastos,
            permisions.editarGastos,
            permisions.verGastosGenerales,
            permisions.verGastosInternos,
            permisions.verIncentivos,
        ],
        compras: [
            permisions.verCompras,
            permisions.verComprasRecurrentes,
            permisions.verSolicitudes,
            permisions.verReclamaciones,
            permisions.verGastos,
            permisions.crearGastos,
            permisions.editarGastos,
            permisions.verGastosGenerales,
            permisions.verGastosInternos,
            permisions.verInventario,
            permisions.verActivoFijo,
            permisions.crearActivoFijo,
            permisions.editarActivoFijo,
            permisions.verUbicaciones,
            permisions.verAlmacenes,
            permisions.verCategorias,
            permisions.verProductos,
            permisions.verServicios,
            permisions.verNotasCredito,
        ],
        gasto: [
            permisions.verSolicitudes,
            permisions.verReclamaciones,
            permisions.verGastos,
            permisions.crearGastos,
            permisions.editarGastos,
            permisions.verGastosGenerales,
            permisions.verInventario,
            permisions.verActivoFijo,
            permisions.crearActivoFijo,
            permisions.editarActivoFijo,
            permisions.verUbicaciones,
            permisions.verAlmacenes,
            permisions.verCategorias,
            permisions.verServicios,
        ],
        digitador: [
            permisions.verSolicitudes,
            permisions.verReclamaciones,
            permisions.verEmpleados,
            permisions.verAusencias,
            permisions.verProgramacion
        ],
        solicitudes: [
            permisions.verSolicitudes,
        ],
        vendedor: [
            permisions.verIngresos,
            permisions.verPedidos,
            permisions.verCotizaciones,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso
        ],
        "vendedor-cliente": [
            permisions.verIngresos,
            permisions.verPedidos,
            permisions.verCotizaciones,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso
        ],
        cobrador: [
            permisions.verPedidos,
            permisions.verCotizaciones,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso,
        ],
        "vendedor-admin": [
            permisions.verIngresos,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.verFacturas,
            permisions.verCotizaciones,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso
        ],
        "vendedor-factura": [
            permisions.verIngresos,
            permisions.verFacturas,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso
        ],
        "vendedor-factura-orden_compra": [
            permisions.verIngresos,
            permisions.verFacturas,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.verConsultas,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso
        ],
        'edu.caja': [
            permisions.verIngresos,
            permisions.verFacturas,
            permisions.verFacturasRecurrentes,
            permisions.verConsultas,
            permisions.verOrdenesCompra,
            permisions.verPedidos,
            permisions.verCuentasPorCobrar,
            permisions.verRecibosIngreso,
            permisions.verContactos,
            permisions.verAcademico,
            permisions.verEvaluaciones,
            permisions.verEstudiantes,
            permisions.verInscripcion,
            permisions.verPadrestutores,
        ],
        'edu.recepcion': [
            permisions.verAcademico,
            permisions.verEvaluaciones,
            permisions.verEstudiantes,
            permisions.verInscripcion,
            permisions.verPadrestutores,
        ],
        'contratos': [
            permisions.verContratos,
            permisions.verContactos,
        ],
    },
    async authenticate(credentials, cb) {
        const { access_token, user, expires_at } = credentials;

        cookie.set("token", access_token, { expires: new Date(expires_at) });
        window.localStorage.setItem("user", JSON.stringify(user));
        window.localStorage.setItem("sucursalActual", user.sucursalActual);
        window.localStorage.setItem("config", JSON.stringify(user.config));
        cb();
    },
    async logout() {
        const token = cookie.get("token");
        cookie.remove("token");

        await fetch(apiUrl("salir"), {
            method: "post",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        // to support logging out from all windows
        window.localStorage.setItem("logout", Date.now());
        window.localStorage.removeItem("sucursalAcual");
        window.localStorage.removeItem("config");
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("rutas");
        window.localStorage.removeItem("almacenes");

        window.location = "/";
    },
    isLoggedIn() {
        const token = cookie.get("token");
        if (!token) {
            return false;
        }
        return token;
    },
    inactivityTime() {
        var time;
        window.onload = resetTimer;

        // DOM Events
        document.onmousemove = resetTimer;
        document.onkeypress = resetTimer;
        document.addEventListener("scroll", resetTimer, true);

        function logout() {
            clearTimeout(time);
            auth.logout();
        }

        function resetTimer() {
            clearTimeout(time);

            if (auth.isLoggedIn()) {
                time = setTimeout(logout, 60000 * 60);
                return;
            }
        }
    },
    esVendedor: () => {
        return auth.getUser().es_vendedor;
    },
    almacenes: () => auth.getUser().almacenes?.filter(a => a.sucursal_id === getSucursal()).map(a => a.id) || [],
    cuentas: () => auth.getUser().cuentas?.filter(c => c.sucursal_id === getSucursal()) || [],
    manejaCuentas: () => auth.getUser().cuentas?.length > 0,
};
